import Http from '@/services/Http';

const BASE_PATH = 'organizations/integrations';
const BASE_PATH_ENVELOPES = 'envelopes/integrations';
const integrations = new Http(BASE_PATH);
const envEnvelopes = new Http(BASE_PATH_ENVELOPES);

integrations.listAll = (organizationId) => {
  return integrations.get('all', {
    headers: { 'X-Organization': organizationId },
  });
};

integrations.listActive = (organizationId) => {
  return integrations.get('', {
    headers: { 'X-Organization': organizationId },
  });
};

integrations.remove = (integrationId, organizationId) =>
  integrations.delete(`${integrationId}`, {
    headers: { 'X-Organization': organizationId },
  });

integrations.create = (organizationId, type, config) => {
  return integrations.post({ type, config }, '', {
    headers: { 'X-Organization': organizationId },
  });
};

integrations.update = (organizationId, integrationId, type, config) =>
  integrations.patch(integrationId, { type, config }, '', {
    headers: { 'X-Organization': organizationId },
  });

integrations.login = (organizationId, type, config) => {
  return envEnvelopes
    .setErrorHandler(() => {}, true)
    .post({ type, config }, `${BASE_PATH_ENVELOPES}/login`, {
      headers: { 'X-Organization': organizationId },
    });
};

export default integrations;
